module.exports = __webpack_public_path__ + "static/media/mountain3.ee9a5e3d.jpg";